import { render } from "./payment-result.vue?vue&type=template&id=b055fb1a&ts=true"
import script from "./payment-result.vue?vue&type=script&lang=ts"
export * from "./payment-result.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__